import {
  ContractItemFormatted,
  FiledClaimItemFormatted,
} from './Counterparty.types';

export const claimsHeaders: { [key in keyof FiledClaimItemFormatted]: string } = {
  refLink: 'Ref ',
  counterpartyName: 'Counterparty name',
  empty: 'empty',
  currentDebtor: 'Current debtor',
  subMatchCode: 'Sub-match code',
  majorCategory: 'Major Category',
  minorCategory: 'Minor Category',
  actionStatus: 'Workflow status',
  resolutionTypeName: 'Resolution type',
  actionSubStatusName: 'Resolution subtype',
  actionName: 'Resolution name',
  originalTotal_formatted: 'Original total',
  currentTotal_formatted: 'Current total',
  proposedTotal_formatted: 'Proposed total',
  currentContingent_formatted: 'Current contingent',
  currentUnliquidated_formatted: 'Current unliquidated',
  currentDisputed_formatted: 'Current disputed',
  officialClaimDate_formatted: 'Date filed',
};

export const boldKeys: string[] = ['refLink', 'counterpartyName'];

export const contractsHeaders: { [key in keyof ContractItemFormatted]: string } = {
  refLink: 'Contract Ref Number',
  counterpartyName: 'Counterparty name',
  empty: 'empty',
  matchCode: 'Match code',
  category: 'Category',
  contractActionName: 'Resolution name',
  contractStatus: 'Workflow status',
  contractActionSubStatusName: 'Resolution subtype',
  primaryDebtor: 'Debtor',
  contractsReviewers: 'Contract owner',
  rejectionDamageLow_formatted: 'Rejection Damages Low',
  rejectionDamagesHigh_formatted: 'Rejection Damages High',
  description: 'Contract title',
};
